<template>
    <div>
        <nav aria-label="items-banner ">
            <div class="nav nav-pills" id="nav-tab" role="tablist">
                <a
                    class="nav-item nav-link active"
                    id="nav-list-tab"
                    data-toggle="tab"
                    href="#nav-list"
                    role="tab"
                    aria-controls="nav-list"
                    aria-selected="true"
                    @click="showList"
                    >Listar</a
                >
                <a
                    class="nav-item nav-link"
                    id="nav-add-tab"
                    data-toggle="tab"
                    href="#nav-add"
                    role="tab"
                    aria-controls="nav-add"
                    aria-selected="false"
                    >Agregar</a
                >
                <a
                    class="nav-item nav-link"
                    id="nav-order-tab"
                    data-toggle="tab"
                    href="#nav-order"
                    role="tab"
                    aria-controls="nav-order"
                    aria-selected="false"
                    >Ordenar</a
                >
            </div>
        </nav>
        <div class="tab-content mt-4" id="nav-tabContent">
            <div
                class="tab-pane fade show active"
                id="nav-list"
                role="tabpanel"
                aria-labelledby="nav-list-tab"
            >
                <component
                    :is="currentComponent"
                    @change-view="changeView"
                    :bannerId="bannerId"
                ></component>
            </div>
            <div
                class="tab-pane fade show"
                id="nav-add"
                role="tabpanel"
                aria-labelledby="nav-add-tab"
            >
                <div class="card">
                    <div class="card-header font-weight-bold">
                        Agregar Banner
                    </div>
                    <div class="card-body">
                        <section-prehome-create-banner-component>
                        </section-prehome-create-banner-component>
                    </div>
                </div>
            </div>
            <div
                class="tab-pane fade show"
                id="nav-order"
                role="tabpanel"
                aria-labelledby="nav-order-tab"
            >
                <div class="card">
                    <div class="card-header font-weight-bold">
                        Ordenar Banners
                        <button
                            type="button"
                            v-tooltip.bottom-start="'Refrescar'"
                            class="btn btn-success btn-sm"
                            @click="getOrderBanners"
                        >
                            <em class="fa fa-refresh"></em>
                        </button>
                    </div>
                    <div class="card-body">
                        <div v-if="loading_" class="text-center">
                            <stretch></stretch>
                            <p class="text-center mt-2">Procesando</p>
                        </div>

                        <p
                            class="text-center mt-2"
                            v-if="!existOrderBanners && !loading_"
                        >
                            Aún no hay ningún banner para ordenar.
                        </p>
                        <draggable
                            :list="orderBanners"
                            class="list-group"
                            ghost-class="ghost"
                            @start="dragging = true"
                            @end="dragging = false"
                            v-if="existOrderBanners"
                        >
                            <div
                                class="list-group-item"
                                v-for="element in orderBanners"
                                :key="element.id"
                                v-html="element.title"
                            ></div>
                        </draggable>
                        <div v-if="orderBanners.length > 1" class="mt-3">
                            <button
                                @click="saveOrderBanners()"
                                type="button"
                                class="btn btn-primary"
                            >
                                Actualizar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helpers from "../../mixins/index";
import { Stretch } from "vue-loading-spinner";
import PrehomeEditBanner from "./SectionPrehomeEditBannerComponent.vue";
import SectionPrehomeBannerList from "./SectionPrehomeBannerList.vue";

export default {
    name: "SectionBannerComponent",
    mixins: [helpers],
    components: {
        Stretch,
        PrehomeEditBanner,
        SectionPrehomeBannerList,
    },
    data() {
        return {
            currentComponent: "SectionPrehomeBannerList",
            orderBanners: [],
            bannerId: null,
            loading_: false,
        };
    },
    computed: {
        existOrderBanners() {
            return this.orderBanners.length > 0;
        },
    },
    methods: {
        getOrderBanners() {
            const me = this;
            me.orderBanners = [];
            me.loading_ = true;

            axios
                .get("/api/banners/order/list")
                .then(function (response) {
                    const { data } = response.data;
                    me.orderBanners = data;
                })
                .catch(function (error) {
                    me.showSwalError(
                        "No fue posible procesar su solicitud, intente mas tarde."
                    );
                })
                .finally(() => {
                    me.loading_ = false;
                });
        },

        saveOrderBanners() {
            const me = this;
            me.loading();
            axios
                .put("/api/banners/order", {
                    order: me.orderBanners,
                })
                .then(function (response) {
                    const { data } = response.data;
                    me.closeLoading();
                    me.showActionSuccess(`${data.message}`);
                })
                .catch(function (error) {
                    me.showSwalError(
                        "No fue posible procesar su solicitud, intente mas tarde."
                    );
                });
        },

        changeView(bannerId) {
            this.bannerId = bannerId;
            this.currentComponent = "PrehomeEditBanner";
        },

        showList() {
            this.bannerId = null;
            this.currentComponent = "SectionPrehomeBannerList";
        },
    },
    mounted() {
        this.getOrderBanners();
    },
};
</script>

<style scoped>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}

.tab-content {
    border: 0.3px solid #f3f5f7ec;
}

.flex-btn {
    display: flex;
    gap: 0.3em;
}
</style>
